import React, { useState } from "react";
import AOS from "aos"; // Import AOS library
import Banner from "../components/Banner";
import OpeningsSec from "../sections/career/OpeningsSec";
import TestimonialSec from "../sections/career/TestimonialSec";
import BenefitsSec from "../sections/career/BenefitsSec";
import EventsSec from "../sections/career/EventsSec";
import * as constants from "../constants";
import { fetchAPI } from "../helper/fetchAPI";
import CustomHelmet from "../components/CustomHelmet";
import { t } from "i18next";
import FullScreenLoader from "../components/FullScreenLoader";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";

const Career = () => {
  const countryPrefix = useCountryPrefix();

  const { i18n } = useTranslation();
  let apiUrl = process.env.REACT_APP_API_URL;
  let apiCmsUrl = process.env.REACT_APP_API_URL;
  const [openings, setOpenings] = useState();
  const [careerCMS, setCareerCMS] = useState();

  const language = i18n.language === "en" ? "en" : i18n.language || "en";
  const [isLoaded, setIsLoaded] = useState(false);


  const fetchData = async () => {
    try {
      apiUrl = `${apiUrl}${constants.career}?language=${language}&region_id=${countryPrefix}`;
      const res = await fetchAPI(apiUrl, "Get");
      if (res?.status === 200) {
        setOpenings(res.data)
        setIsLoaded(true)
      } else { setIsLoaded(true) }

      apiCmsUrl = `${apiCmsUrl}${constants.cmscareer}?language=${language}&region_id=${countryPrefix}`;
      const resBenefits = await fetchAPI(apiCmsUrl, "Get");
      if (resBenefits?.status === 200) {

        setCareerCMS(resBenefits.data)
        setIsLoaded(true)
      } else { setIsLoaded(true) }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    AOS.init();
    fetchData()
  }, []);

  if (!isLoaded) {
    return (
      <FullScreenLoader />
    )
  }

  return (
    <>
      <CustomHelmet
        title={"Exclusive Real Estate Across Egypt"}
        desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
      />
      <Banner
        title={careerCMS?.title}
        desc={careerCMS?.description}
        cssClass={"career-intro-text"}
      ></Banner>
      <OpeningsSec Openings={openings} />
      {/* <TestimonialSec /> */}

      <BenefitsSec data={careerCMS} />
      {/* <EventsSec /> */}
    </>
  );
};

export default Career;
